import { hot } from 'react-hot-loader/root';
import Component from './compatibility-redux';

export default hot(Component);
